import { useState } from "react";

import {
  EXPORT_COLUMN_HEADERS,
  EXPORT_COLUMN_KEYS,
} from "../constants/columns";

import { useCurrentCompany } from "../../../../../hooks/useCurrentCompany";

import {
  appName,
  formatDateForExcelHeader,
} from "../../../../../utils/excelUtils";

import { downloadFileBase64 } from "../../../../../utils/utils";

import { getDateTime } from "../../../../Queries/components/utils";

const wchCols = Object.values(EXPORT_COLUMN_KEYS).map((value) => ({
  wch: value.length + 20,
}));

const processData = (rowsToBeExported) => {
  const transformedRows = rowsToBeExported.map((cell) => {
    const cellObj = {};

    Object.keys(cell).forEach((key) => {
      const item = {
        value: cell[key],
        style: {
          horizontalAlignment: "center",
          verticalAlignment: "bottom",
        },
      };

      cellObj[key] = item;
    });

    return cellObj;
  });

  return transformedRows;
};

// Use the same comparator PrimeReact uses.
const sortByField = (data, { field, order }) =>
  [...data].sort((a, b) => {
    const valA = a[field];
    const valB = b[field];

    if (valA == null && valB != null) return -order;
    if (valA != null && valB == null) return order;
    if (valA == null && valB == null) return 0;

    if (typeof valA === "string" && typeof valB === "string")
      return order * valA.localeCompare(valB);

    return order * (valA < valB ? -1 : valA > valB ? 1 : 0);
  });

const dataToExcel = (dataToExport, sortConfig, companyName) => {
  const data = sortByField(dataToExport, sortConfig[0]);

  const dataExcel = data.map(({ active, ...rest }) => ({
    ...rest,
    active: active ? "Sí" : "No",
  }));

  const toExcel = {
    filename: "Permisos",
    templateFileName: "simple_template.xlsx",
    replace: [
      {
        type: 0,
        tag: "#simple.name",
        prop: "name",
        default: "Simple",
      },
      {
        type: 1,
        tag: "#simple.company",
        prop: "company",
        default: "Simple",
      },
      {
        type: 1,
        tag: "#printDate",
        prop: "printDate",
        default: new Date().toLocaleDateString(),
        format: ["numberFormat", "dd mmmm yyyy"],
      },
      {
        type: 1,
        tag: "#simple.appName",
        prop: "appName",
        default: "Simple",
      },
      {
        type: 1,
        tag: "#simple.name",
        prop: "name",
        default: "Simple",
      },
      {
        type: 2,
        tag: "#simple.cols",
        prop: "cols",
      },
      {
        type: 4,
        tag: "#simple.rows",
        prop: "rows",
        colprop: "cols",
        default: "N/D",
      },
    ],
    data: {
      company: companyName,
      autoFilter: true,
      gridLinesVisible: true,
      printDate: formatDateForExcelHeader(new Date()),
      appName: appName,
      name: "Permisos",
      cols: [],
      rows: processData(dataExcel),
    },
  };

  Object.values(EXPORT_COLUMN_KEYS).forEach((key, index) => {
    toExcel.data.cols.push({
      title: EXPORT_COLUMN_HEADERS[key],
      prop: key,
      width: wchCols[index].wch,
    });
  });

  return toExcel;
};

export const useExportToExcel = () => {
  const companyInfo = useCurrentCompany();

  const [isExporting, setIsExporting] = useState(false);

  const exportToExcel = async ({ data, sortConfig }) => {
    try {
      setIsExporting(true);

      const toExcel = dataToExcel(data, sortConfig, companyInfo?.name);

      const dateName = getDateTime();

      await downloadFileBase64(toExcel, "xlsx", `Permisos_${dateName}`);
    } finally {
      setIsExporting(false);
    }
  };

  return { exportToExcel, isExporting };
};
